import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Button
} from '@material-ui/core';
// import { Cancel } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

function RemoveGroupPatientModal(props) {
    const {
        open,
        save,
        onClose,
        classes: { modal, modalContent, submitButton, cancelButton, actions , modalTitleText },
    } = props;

    return (
        <>
            <Dialog
                fullWidth
                open={open}
                onClose={onClose}
                classes={{ paper: modal }}
                maxWidth={'md'}
            >
                <DialogTitle>
                    <Grid container alignItems="center">
                        <Grid item xs={11}>
                            <h2 className={modalTitleText}>
                                Are you sure you want to remove patient from provider group?
                            </h2>
                        </Grid>

                        <div className={actions}>
                            <Button
                                onClick={onClose} 
                                variant="outlined"
                                color="primary"
                                className={cancelButton}>
                                Cancel
          </Button>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={save}
                                className={submitButton}
                            >
                                Submit
                            </Button>
                        </div>
                    </Grid>
                </DialogTitle>
                <DialogContent classes={{ root: modalContent }}>
                </DialogContent>
            </Dialog>
        </>
    );
}

RemoveGroupPatientModal.propTypes = {
    viewOnly: PropTypes.bool,
    note: PropTypes.object,
    patient: PropTypes.object,
    open: PropTypes.bool.isRequired,
    save: PropTypes.func,
    onClose: PropTypes.func.isRequired,
};

const styles = () => ({
    modal: {
        maxHeight: '700px',
        maxWidth: '500px !important'
    },
    modalTitleText: {
        lineHeight: 'normal',
        fontSize: '24px'
    },
    modalContent: {
        overflow: 'visible',
    },
    actions: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
        '@media only screen and (max-width: 1024px)': {
          flexDirection: 'column-reverse',
          justifyContent: 'center',
        },
      },
    input: {
        margin: '0.5em 0',
    },
    selectInput: {
        marginTop: '0.5em',
        marginBottom: '1em',
    },
    previewImg: {
        maxWidth: 300,
        maxHeight: 300,
    },
    submitButton: {
        color: 'white',
        minWidth: 'auto',
        marginLeft: '15px',
        '@media only screen and (max-width: 1024px)': {
            padding: '1em',
            marginLeft: '0',
            marginBottom: '1em',
        },
    },
    cancelButton: {
        minWidth: 'auto',
    },
});

export default withStyles(styles)(RemoveGroupPatientModal);
